// src/components/seo/StoreJsonLd.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface StoreJsonLdProps {
  storeName?: string;
  storeUrl?: string;
  logoUrl?: string;
  description?: string;
}

const StoreJsonLd: React.FC<StoreJsonLdProps> = ({
  storeName = "سوق المتاجر المتعددة",
  storeUrl = window.location.origin,
  logoUrl = `${window.location.origin}/logo.png`,
  description = "منصة سوق المتاجر المتعددة: تسوق منتجات متنوعة من آلاف المتاجر بأقل الأسعار، واحصل على متجرك الإلكتروني الخاص بتكلفة رمزية. أفضل تجربة تسوق وبيع في مصر."
}) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": storeName,
    "url": storeUrl,
    "logo": logoUrl,
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "EG",
      "addressRegion": "القاهرة",
      "addressLocality": "القاهرة",
      "postalCode": "11511",
      "streetAddress": "شارع التسعين، القاهرة الجديدة"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Arabic",
      "email": "info@codeocean.com"
    },
    "sameAs": [
      "https://www.facebook.com/share/19rgKDR91s/?mibextid=wwXIfr",
      "https://instagram.com/bazaar_marketplace"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default StoreJsonLd;